import { useCallback } from 'react';
import axios from 'axios';
import { getBaseUrl } from '../utils/request';

const useFetchProductCookie = ({
    sessionId,
    setProductCookie
}) => {
    return useCallback(async () => {
		try {
			const response = await axios.get(getBaseUrl()+`/vedai/get-product-cookie?sessionId=${sessionId}`);
			if (response.data.data.product) {
				setProductCookie(response.data.data.product);
			}
		} catch (error) {
			console.error("Error fetching product cookie:", error);
		}
	}, [sessionId,setProductCookie]);
};

export default useFetchProductCookie;